interface StarRatingProps {
  level: number;
  setLevel: (level: number) => void;
}

const StarRating = ({ level, setLevel }: StarRatingProps) => {
  const totalStars = 3;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      {Array.from({ length: totalStars }).map((_, index) => (
        <img
          key={index}
          src={
            index < level
              ? '/assets/images/icon/star-blue.svg'
              : '/assets/images/icon/star-gray.svg'
          }
          alt={`star-${index}`}
          style={{ width: 24, cursor: 'pointer' }}
          onClick={() => setLevel(index + 1)}
        />
      ))}
    </div>
  );
};

export default StarRating;
